import { PubOwnerDomain } from "../../api/cafe";

export interface IMenuItem {
  name: string;
  path: string[];
  children?: Array<IMenuItem>;
  icon: string;
  domain?: PubOwnerDomain | null;
}

export const DEFAULT_MENU: IMenuItem[] = [
  {
    name: "대시보드",
    path: ["/"],
    icon: "dashboard.svg",
    domain: null,
  },
];

export const MENU: IMenuItem[] = [
  {
    name: "대시보드",
    path: ["/"],
    icon: "dashboard.svg",
    domain: null,
  },
  {
    name: "토너먼트",
    path: ["/tournament"],
    icon: "tournament.svg",
    domain: PubOwnerDomain.TOURNAMENT,
  },
  {
    name: "예약 관리",
    path: ["/reservation"],
    icon: "user-web.svg",
    domain: PubOwnerDomain.RESERVATION,
  },
  {
    name: "펍 관리",
    path: ["/management"],
    icon: "management.svg",
    domain: PubOwnerDomain.MANAGEMENT,
  },
  {
    name: "마케팅 서비스",
    path: ["/push", "/pushSend", "/pushDetail"],
    icon: "push.svg",
    domain: PubOwnerDomain.MARKETING,
    children: [
      {
        name: "PUSH 메시지",
        path: ["/push", "/pushSend/*", "/pushDetail/*"],
        icon: "",
      },
      {
        name: "포스터 생성",
        path: ["/poster-maker"],
        icon: "",
      },
    ],
  },
  {
    name: "티켓 관리",
    path: ["/ticket-store", "/ticket-request"],
    icon: "tournament-ticket.svg",
    domain: PubOwnerDomain.TICKET,
    children: [
      {
        name: "매장 티켓",
        path: ["/ticket-store"],
        icon: "",
      },
      {
        name: "교환 요청",
        path: ["/ticket-request"],
        icon: "",
      },
    ],
  },
  {
    name: "정산",
    path: ["/solution", "/daily-settlement", "/month-settlement"],
    icon: "solution.svg",
    domain: PubOwnerDomain.SETTLEMENT,
    children: [
      {
        name: "대시보드",
        path: ["/solution"],
        icon: "",
      },
      ...(process.env.REACT_APP_ENV !== "production"
        ? [
            {
              name: "일일 정산",
              path: ["/daily-settlement"],
              icon: "",
            },
            {
              name: "월간 결산",
              path: ["/month-settlement"],
              icon: "",
            },
          ]
        : []),
    ],
  },
  {
    name: "회원관리",
    path: ["/member"],
    icon: "member.svg",
    domain: PubOwnerDomain.MEMBER,
  },
  {
    name: "이벤트",
    path: [
      "/event/mission",
      "/event/bingo",
      "/event/member-progress",
      "/event/logs",
    ],
    icon: "event.svg",
    domain: PubOwnerDomain.EVENT,
    children: [
      {
        name: "미션관리",
        path: ["/event/mission"],
        icon: "",
      },
      {
        name: "빙고관리",
        path: ["/event/bingo"],
        icon: "",
      },
      {
        name: "유저진행현황",
        path: ["/event/member-progress"],
        icon: "",
      },
      {
        name: "처리내역",
        path: ["/event/logs"],
        icon: "",
      },
    ],
  },
  {
    name: "보안",
    path: ["/owners"],
    icon: "owners.svg",
    domain: null,
  },
];
